export const isDesktop = () => window.matchMedia('(min-width: 1224px)').matches
export const isMobile = () => window.matchMedia('(max-width: 768px)').matches
export const isLargeScreen = () => window.matchMedia('(min-width : 1824px)').matches



// WEBPACK FOOTER //
// ./src/App/components/Devices/mediaCheckers.js